import { Box, Link, Stack, Typography } from '@mui/material';

import { Button } from '@karehero/llama/components/atoms/Button/Button';

import StatusBar from '@/designs-dev/device/StatusBar';
import HomeIndicator from '@/designs-dev/device/HomeIndicator';
import ScreenRoot from '@/components/wrapped/ScreenRoot';

// Member-facing entry screen for the KareHero App prototype.
const WelcomeScreen = ({
  onCreateAccount,
  onSignIn,
  onForgotPassword,
}: {
  onCreateAccount: () => void;
  onSignIn: () => void;
  onForgotPassword: () => void;
}) => (
  <ScreenRoot>
    <StatusBar />

    {/* brand + greeting */}
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        px: 3,
      }}
    >
      <Box
        sx={{ width: 42, height: 'auto', mb: 4 }}
        component='img'
        src='/vector/karehero-logo.png'
        alt='KareHero'
      />
      {/* display1, not h1: the brand voice is asked for by name. h1 is Work Sans
          since the heading ramp moved, so the serif no longer comes with being
          the biggest heading on the screen. */}
      <Typography
        sx={{ mb: 1.5, color: 'custom.marineGreen.500' }}
        variant='display1'
      >
        Welcome to KareHero
      </Typography>
      <Typography variant='body1' color='text.secondary'>
        Real care experts at your fingertips to help you find, fund and
        understand the right care.
      </Typography>
    </Box>

    {/* actions — 16px between buttons */}
    <Stack sx={{ px: 3, alignItems: 'center' }} spacing={2}>
      <Button
        variant='primary'
        size='lg'
        isFullWidth
        ariaLabel='Create account'
        onPress={onCreateAccount}
      >
        Create account
      </Button>
      <Button
        variant='secondary'
        size='lg'
        isFullWidth
        ariaLabel='Sign in'
        onPress={onSignIn}
      >
        Sign in
      </Button>
      <Link
        component='button'
        type='button'
        variant='body2'
        onClick={onForgotPassword}
        sx={{ mt: 0.5 }}
      >
        Forgot password?
      </Link>
    </Stack>

    <HomeIndicator />
  </ScreenRoot>
);

export default WelcomeScreen;
